export const landingFormalitiesSecurityGuidelinesInitalProps = async ({
  routeInfo,
  context: {
    domain,
    i18n: {culture}
  }
}) => {
  const {
    location: {pathname: path}
  } = routeInfo

  const config = domain.get('config')
  const {pageName} = await domain.get('get_page_name_page_use_case').execute({path})
  const breadCrumbPromise = domain.get('get_breadcrumbs_breadcrumb_use_case').execute({pageName})
  const seoDataPromise = domain.get('get_seo_data_use_case').execute({
    culture,
    pageName
  })

  const [
    {value: [breadcrumbError, breadcrumb] = []},
    {
      value: [seoDataError, {head: helmet} = {}]
    }
  ] = await Promise.allSettled([breadCrumbPromise, seoDataPromise])

  const pageErrors = {
    breadcrumbError,
    seoDataError
  }

  return {breadcrumb, helmet, pageName, pageErrors, tenant: config.get('TENANT')}
}
